import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {editor} from "@/app/editor";
import {GroupModuleV1} from "@/app/editor/modules/group/v1/index";
import GroupProductsTableView from "@/app/editor/modules/group/v1/view/GroupProductsTableView.vue";
import BlockContentBox from "@/components/block/BlockContentBox.vue";
import BlockContentItemValue from "@/components/block/BlockContentItemValue.vue";
import BlockContentItemKey from "@/components/block/BlockContentItemKey.vue";
import ValidInputNumber from "@/app/editor/modules/group/v1/view/ValidInputNumber.vue";
import ImagesUploader from "@/app/editor/views/ImagesUploader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupSimple',
  props: {
    index: {}
  },
  setup(__props: any) {


const props = __props
const group = editor.activity?.modules[props.index] as GroupModuleV1



return (_ctx: any,_cache: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BlockContentBox, null, {
      default: _withCtx(() => [
        _createVNode(BlockContentItemKey, null, {
          default: _withCtx(() => [
            _createTextVNode("团购价")
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemValue, null, {
          default: _withCtx(() => [
            _createVNode(ValidInputNumber, {
              placeholder: "点击输入团购价",
              max: 999,
              min: 0.1,
              "addon-after": "元",
              value: _unref(group).config.goods.sell_price,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(group).config.goods.sell_price) = $event)),
              onChange: _cache[1] || (_cache[1] = v => _unref(group).config.steps[0].price=v),
              valid: v => v<=0 ? '未设置' :  null
            }, null, 8, ["value", "valid"])
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemKey, null, {
          default: _withCtx(() => [
            _createTextVNode("成团人数")
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemValue, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_number, {
              placeholder: "点击输入成团人数",
              max: 99,
              min: 2,
              "addon-after": "人",
              value: _unref(group).config.steps[0].group_size,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(group).config.steps[0].group_size) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemKey, null, {
          default: _withCtx(() => [
            _createTextVNode("库存数量")
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemValue, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_number, {
              placeholder: "点击输入库存数量",
              max: 9999,
              min: 1,
              "addon-after": "个",
              value: _unref(group).config.goods.stock,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(group).config.goods.stock) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemKey, null, {
          default: _withCtx(() => [
            _createTextVNode("团长免单")
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemValue, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_switch, {
              checked: _unref(group).config.goods.leader_free,
              "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_unref(group).config.goods.leader_free) = $event))
            }, null, 8, ["checked"]),
            _hoisted_1,
            _createVNode(_component_a_typography_text, { type: "secondary" }, {
              default: _withCtx(() => [
                _createTextVNode("开启后系统不处理免单，店家自行处理 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemKey, null, {
          default: _withCtx(() => [
            _createTextVNode("组团优惠设计图")
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemValue, null, {
          default: _withCtx(() => [
            _createVNode(ImagesUploader, {
              images: _unref(group).config.props.group_info_picture,
              "onUpdate:images": _cache[5] || (_cache[5] = ($event: any) => ((_unref(group).config.props.group_info_picture) = $event)),
              max: 1
            }, null, 8, ["images"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(GroupProductsTableView, {
      items: _unref(group).config.steps[0].items,
      "onUpdate:items": _cache[6] || (_cache[6] = ($event: any) => ((_unref(group).config.steps[0].items) = $event))
    }, null, 8, ["items"]),
    _createVNode(GroupProductsTableView, {
      items: _unref(group).config.fail_items,
      "onUpdate:items": _cache[7] || (_cache[7] = ($event: any) => ((_unref(group).config.fail_items) = $event)),
      "is-fail": ""
    }, null, 8, ["items"])
  ], 64))
}
}

})